// extracted by mini-css-extract-plugin
export default {"container":"wwlHl","title":"BVBDn","appsContainer":"_1sKf5","appsLink":"NdQaF","qrCodeContainer":"UANxG","text":"hBNhF","skeleton-progress":"qOeJk"};